module.exports = __webpack_public_path__ + "img/assuraf_banner_2.d54903fb.jpg";